<!-- results-table.component.html -->
<h1 mat-dialog-title></h1>
<div mat-dialog-content fxLayout="column">
    <div fxLayout="column" fxFlex="100">
        <div fxLayout="column" fxFlex="100" class="print">
            <div fxLayout="row" class="p-20">
                <div fxFlex fxLayout="row">
                    <div fxFlex="50">
                        <strong>{{ organizacion }}</strong>
                    </div>
                    <div fxFlex="50" fxLayout="column">
                        <div fxFlex fxLayoutAlign="end start">
                            <img
                                class="logo-icon"
                                src="assets/images/logos/logo_RIC_horizontal_transparente.png"
                                height="67"
                                width="200"
                            />
                        </div>
                        <div
                            fxFlex
                            fxLayoutAlign="end start"
                            style="margin-right: 20px"
                        >
                            {{ fecha | date : "dd/MM/yyyy" }}
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <h1 class="p-20"><strong>Listado de Cumplimiento</strong></h1>
            </div>

            <div fxLayout="column" class="p-20">
                <div fxFlex fxLayout="row" class="p-10">
                    <div fxFlex="70">
                        <strong>Regla Base: </strong
                        >{{ LOCAL_DATA.reglaBase.nombre }}
                    </div>
                    <div fxFlex="30">
                        <strong>Fecha inicio: </strong
                        >{{ LOCAL_DATA?.fechaInicio | date : "dd/MM/yyyy" }}
                    </div>
                </div>
                <div fxFlex fxLayout="row" class="p-10">
                    <div fxFlex="70">
                        <strong>Estructura jerarquíca: </strong
                        >{{ LOCAL_DATA.estructuraJerarquica.nombre }} /
                        {{ LOCAL_DATA.nodoEstructuraJerarquica.nombre }}
                    </div>
                    <div fxFlex="30">
                        <strong>Fecha fin: </strong
                        >{{ LOCAL_DATA?.fechaFin | date : "dd/MM/yyyy" }}
                    </div>
                </div>
                <div fxFlex fxLayout="row" class="p-10">
                    <div fxFlex="70">
                        <strong>Nodo: </strong
                        >{{ LOCAL_DATA.nodoEstructuraJerarquica.nombre }}
                    </div>
                </div>
                <div fxFlex fxLayout="row" class="p-10">
                    <div fxFlex="70">
                        <strong>Evaluaciones: </strong>
                        <span
                            *ngFor="
                                let evaluacion of LOCAL_DATA.evaluaciones;
                                let isLast = last
                            "
                            >{{ evaluacion.nombre }}
                            {{ isLast ? "" : ", " }}</span
                        >
                    </div>
                </div>
            </div>
        </div>

        <div fxLayout="column" fxFlex="100">
            <div class="content" fxFlex="100" fxLayout="row">
                <div fxFlex class="content p-20">
                    <table
                        mat-table
                        [dataSource]="dataSource"
                        #tableProbabilidad
                        class="my-table mat-elevation-z8 select-list"
                        fxFlex
                    >
                        <ng-container matColumnDef="mandato">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Mandato
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <!--<span
                                    ><a class="m-5"
                                        ><mat-icon
                                            class="secondary-text"
                                            (click)="
                                                openDetailsialog(
                                                    element.mandato,
                                                    element.subMandato,
                                                    element.cumplimiento
                                                )
                                            "
                                            >visibility</mat-icon
                                        ></a
                                    ></span
                                >-->
                                <span
                                    ><strong>{{
                                        element.mandato.nombre
                                    }}</strong>
                                    | {{ element.mandato.descripcion }}</span
                                >
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="submandato">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Sub-Mandato
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span
                                    ><strong
                                        >{{
                                            element.subMandato?.nombre
                                        }} </strong
                                    >|
                                    {{ element.subMandato?.descripcion }}</span
                                >
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cumplimiento">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Coincidencias
                            </th>

                            <td
                                mat-cell
                                *matCellDef="let element"
                                fxLayout="column"
                            >
                                <div
                                    fxFlex
                                    fxLayout="column"
                                    class="p-10"
                                    *ngFor="let item of element.cumplimiento"
                                >
                                    <div fxLayout="row">
                                        <div fxFlex="19">
                                            <strong>Control: </strong>
                                        </div>
                                        <div fxFlex="80">
                                            {{ item.control }}
                                        </div>
                                    </div>
                                    <div fxLayout="row">
                                        <div fxFlex="19">
                                            <strong>Evaluación: </strong>
                                        </div>
                                        <div fxFlex="80">
                                            {{ item.evaluacion }}
                                            (Versión {{ item.version }})
                                        </div>
                                    </div>
                                    <!--<div fxLayout="row">
                                        <div fxFlex="19">
                                            <strong>Resultado: </strong>
                                        </div>
                                        <div fxFlex="80">
                                            {{ item.resultado }}
                                        </div>
                                    </div>-->
                                    <div fxLayout="row">
                                        <div fxFlex="19">
                                            <strong>Razón: </strong>
                                        </div>
                                        <div fxFlex="80">
                                            {{ item.razon }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumns"
                            class="print"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumns"
                            class="print"
                        ></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="printPdf()">
            {{ "Imprimir" | translate }}
        </button>
        <button mat-button (click)="closeDialog()" mat-flat-button color="warn">
            {{ "Cancel" | translate }}
        </button>
    </div>
</div>
